const togglePs = {
  methods: {
    togglePs(toggle) {
      const sidebar = document.querySelector('.sidebar-nav section')
      if (sidebar) {
        // sidebar.classList.toggle('ps', toggle);
        // sidebar.classList.toggle('ps-container', toggle);
        // sidebar.classList.toggle('ps--active-y', toggle);
        if (toggle) {
          sidebar.classList.add('ps', 'ps-container', 'ps--active-y')
        } else {
          sidebar.classList.remove('ps', 'ps-container', 'ps--active-y')
        }
      }
    }
  }
}

export { togglePs }



//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/vue/src/mixins/togglePs.js
// module id = Ii3O
// module chunks = 0